import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from 'firebase/database';
import { getFirestore, initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { fbAppConfigs } from "../../project/appConfigs";
import { _projectAppNames, getAppInfo } from "../../project/appConfiguration";

const { appName } = getAppInfo(true);
const { appName: appName_alt } = getAppInfo();

const _showLogs = false
const _useCache = false

export const _firebaseAppTypes = {
  app: 'app',
  auth: 'auth',
  database: 'database',
  realtime: 'realtime',
  functions: 'functions',
  storage: 'storage',
}

// Determine environment
let _environment = 'dev';

if (appName === _projectAppNames.meetingevolution) {
  _environment = document.location.host === 'mobile.events.meetingevolution.net' ? 'prod' : 'dev';
}

// Initialize PRIMARY app with the appropriate environment config
const primaryConfig = fbAppConfigs[appName][_environment];
const appNameKey = `${appName}_${_environment}`;

_showLogs && console.log(`Initializing Firebase for: ${appNameKey}`, appName, _environment);

const firebaseApp = getApps().length ? getApp(appNameKey) : initializeApp(primaryConfig, appNameKey);

let firebaseApp_alt;
let firebaseApp_prod;

if (appName !== appName_alt) {

  _showLogs && console.log('appName_alt', appName_alt)

  const altConfig = fbAppConfigs[appName_alt]['dev'];
  const appNameKey_alt = `${appName_alt}_${'dev'}`;

  _showLogs && console.log(`Initializing Alt Firebase for ${appNameKey_alt}`);

  firebaseApp_alt = getApps().find(app => app.name === appNameKey_alt)
    ? getApp(appNameKey_alt)
    : initializeApp(altConfig, appNameKey_alt);
}

switch (appName) {
  case _projectAppNames.meetingevolution:
    switch (_environment) {
      case 'dev':
        const prodConfig = fbAppConfigs.meetingevolution['prod'];
        const appNameKey_prod = `${appName}_${'prod'}`;
        firebaseApp_prod = getApps().find(app => app.name === appNameKey_prod)
          ? getApp(appNameKey_prod)
          : initializeApp(prodConfig, appNameKey_prod);
    }
}

_showLogs && console.log('firebaseApp', firebaseApp);
_showLogs && console.log('firebaseApp_alt', firebaseApp_alt);
_showLogs && console.log('firebaseApp_prod', firebaseApp_prod);

let authInstance;
let dbInstance;
let rtInstance;
let functionsInstance;
let storageInstance;

const instances_alt = {
  auth: null,
  db: null,
  rt: null,
  fn: null,
  st: null
}

const instances_prod = {
  auth: null,
  db: null,
  rt: null,
  fn: null,
  st: null
}

export const getFirebaseAuth = () => {
  if (!authInstance) {
    _showLogs && console.log('Initializing Firebase Auth');
    authInstance = getAuth(firebaseApp_alt ? firebaseApp_alt : firebaseApp);
  }
  return authInstance;
};

export const getFirebaseDb = (alt) => {
  if (!dbInstance) {
    _showLogs && console.log('Initializing Firestore');
    if (_useCache) {
      dbInstance = initializeFirestore(firebaseApp, {
        localCache: persistentLocalCache({
          cacheSizeBytes: 40 * 1024 * 1024, // example: 40 MB
        }),
      });
    } else {
      dbInstance = alt && firebaseApp_alt ? getFirestore(firebaseApp_alt) : getFirestore(firebaseApp);
    }
    _showLogs && console.log('dbInstance', dbInstance)
  }
  return dbInstance;
};

export const getRealtimeDb = () => {
  if (!rtInstance) {
    _showLogs && console.log('Initializing Realtime Database');
    rtInstance = getDatabase(firebaseApp);
    _showLogs && console.log('rtInstance', rtInstance)
  }
  return rtInstance;
};

export const getFirebaseFunctions = () => {
  if (!functionsInstance) {
    _showLogs && console.log('Initializing Functions');
    functionsInstance = getFunctions(firebaseApp);
  }
  return functionsInstance;
};

export const getFirebaseStorage = () => {
  if (!storageInstance) {
    _showLogs && console.log('Initializing Storage');
    storageInstance = getStorage(firebaseApp);
  }
  return storageInstance;
};

// alts
export const getFirebaseAlts = (firebaseAppType) => {
  if (firebaseApp_alt) {
    _showLogs && console.log('Initializing Firebase Alt - ' + firebaseAppType);
    switch (firebaseAppType) {
      case _firebaseAppTypes.app:
        return firebaseApp_alt
      case _firebaseAppTypes.auth:
        return !instances_alt.auth ? getAuth(firebaseApp_alt) : instances_alt.auth
      case _firebaseAppTypes.database:
        return !instances_alt.db ? getFirestore(firebaseApp_alt) : instances_alt.db
      case _firebaseAppTypes.functions:
        return !instances_alt.fn ? getFunctions(firebaseApp_alt) : instances_alt.fn
      case _firebaseAppTypes.storage:
        return !instances_alt.st ? getStorage(firebaseApp_alt) : instances_alt.st
      case _firebaseAppTypes.realtime:
        return !instances_alt.rt ? getDatabase(firebaseApp_alt) : instances_alt.rt
    }
  }
}

export const getFirebaseProds = (firebaseAppType) => {
  if (firebaseApp_prod) {
    _showLogs && console.log('Initializing Firebase Prod - ' + firebaseAppType);
    switch (firebaseAppType) {
      case _firebaseAppTypes.app:
        return firebaseApp_prod
      case _firebaseAppTypes.auth:
        return !instances_prod.auth ? getAuth(firebaseApp_prod) : instances_prod.auth
      case _firebaseAppTypes.database:
        return !instances_prod.db ? getFirestore(firebaseApp_prod) : instances_prod.db
      case _firebaseAppTypes.functions:
        return !instances_prod.fn ? getFunctions(firebaseApp_prod) : instances_prod.fn
      case _firebaseAppTypes.storage:
        return !instances_prod.st ? getStorage(firebaseApp_prod) : instances_prod.st
      case _firebaseAppTypes.realtime:
        return !instances_prod.rt ? getDatabase(firebaseApp_prod) : instances_prod.rt
    }
  }
}
